export default function shouldFireOnFocus(
  isFocused: boolean,
  queryClient: any,
  refetch: () => void,
  setBankForTransfer: (value: null) => void,
): void {
  if (isFocused) {
    queryClient.invalidateQueries({ queryKey: ['me_api'] }).then(() => {
      refetch();
    });
    setBankForTransfer(null);
  }
}
